import React, { useEffect } from 'react';
import { AppBar, IconButton, Typography, Toolbar } from '@material-ui/core';
// import MenuIcon from '@material-ui/icons/Menu';
import { makeStyles, Theme } from '@material-ui/core/styles';
import LogUtils from '../utils/logUtils';

/***********************************************************************
 * 型定義
 ***********************************************************************/

/***********************************************************************
 * Style
 ***********************************************************************/
/**
 * スタイル定義
 * @name useStyles
 */
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

/***********************************************************************
 * メイン処理
 ***********************************************************************/
/**
 * 画面の一番上のバー画面
 * @name AppBarComponent
 */
const AppBarComponent: React.FC = () => {
  /**
   * クラス名
   * @name className
   * @member
   */
  const className = 'AppBarComponent';
  /**
   * スタイル定義
   * @name classes
   * @member
   */
  const classes = useStyles();

  /**
   * 副作用フック定義
   * @name useEffect
   * @function
   */
  useEffect(() => {
    /**
     * 初期設定処理
     * @name init
     */
    const init = async () => {
      const methodName = 'init';
      try {
        LogUtils.info(`${className} ${methodName} start`);
        LogUtils.info(`${className} ${methodName} end`);
      } catch (e) {
        LogUtils.error(`${className} ${methodName} Error: ${e}`);
      }
    };
    init();
  }, []);

  /***********************************************************************
   * 画面の定義
   ***********************************************************************/
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
          >
            {/* <MenuIcon /> */}
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            郵便番号か住所を調べる
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default AppBarComponent;
